import axios from "axios";
import Cookies from "js-cookie"; // Ensure js-cookie is installed
import { handleToast, logout } from "./helper";
import { fetchCsrfCookie } from "@/utils/csrf";

// Create an Axios instance
const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_COMMON_BASE_URL, // Use your backend base URL
  headers: {
    "X-Requested-With": "XMLHttpRequest", // Identifies the request as an AJAX call
  },
  withCredentials: true, // Ensures cookies are sent with requests
  validateStatus: (status) => status >= 200 && status < 400, // Treat 302 as a success
});

// Request interceptor: Adds CSRF and Authorization tokens to headers
instance.interceptors.request.use(
  (config) => {
    // Fetch CSRF token (XSRF-TOKEN) from cookies
    const xsrfToken = Cookies.get("XSRF-TOKEN");

    if (xsrfToken) {
      config.headers["X-XSRF-TOKEN"] = xsrfToken;
    }

    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error); // Reject the error to propagate it to the calling function
  }
);

// Flag to track logout state (prevents infinite loop)
let isLoggingOut = false;

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      const { data, status } = error.response;
      let errorMessage = "An unknown error occurred";

      // Handle 401, 403, 419 (Session Expired) errors
      if (status === 419) {
        try {
          await fetchCsrfCookie();
        } catch (csrfErr) {
          console.error("CSRF refresh failed", csrfErr);
          return Promise.reject(error);
        }
      }
      // if ((status === 401 || status === 403) && !
      if (status === 401 && !isLoggingOut) {
        isLoggingOut = true;
        // try {
        //   instance.post("/logout");
        // } catch (logoutError) {
        //   console.error("Logout request failed:", logoutError);
        // }

        await logout();
        window.location.reload();
        return Promise.reject(error);
      }

      if (status === 404) {
        // return error?.response;
        return Promise.reject(error);
      }

      if (data && data.errors) {
        if (Array.isArray(data.errors)) {
          // If it's an array of messages
          errorMessage = data.errors.join(", ");
        } else if (typeof data.errors === "object") {
          const messages = Object.values(data.errors)
            .flat() // flatten arrays of messages
            .join(", ");
          errorMessage = messages || "Validation errors occurred.";
        } else {
          errorMessage = "Validation errors occurred.";
        }
      } else if (data && data.message) {
        errorMessage = data.message;
      } else {
        errorMessage = "Something went wrong.";
      }
      if (status === 422) {
        try {
          await fetchCsrfCookie();
          handleToast({
            err: { response: { data: { message: errorMessage } } },
          });
        } catch (csrfErr) {
          console.error("CSRF refresh failed", csrfErr);
        }
        return Promise.reject(error);
      } else {
        // Show error in toast
        handleToast({
          err: { response: { data: { message: errorMessage } } },
        });
      }

      console.error("Error response:", error?.response);
      return Promise.reject(error);
    } else {
      // Handle general errors without a response
      console.error("Error message:", error?.message);
      handleToast({
        err: { response: { data: { message: error?.message } } },
      });
    }

    return Promise.reject(error); // Ensure the error is still returned
  }
);

export default instance;
